import React from 'react';
import './tabs.sass';

export class Tabs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTabId: 0,
    }
    this.mounted = false;
    this.children = [];
    
  }

  componentDidMount() {
    this.mounted = true;
    this.setChildren();
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidUpdate(prevProps) {
    if (this.mounted && this.props.children !== prevProps.children) {
      this.setChildren();
    }
  }

  setChildren() {
    let activeTabId = 0;
    this.children = this.props.children.map((child, i) => {
      if (!child.props.title) return null;
      if (child.props.active) {
        activeTabId = i;
      }
      return {id: i, title: child.props.title, content: child};
    }).filter(item => item);
    this.setState({
      activeTabId,
    }); 
  }

  activateTab = (activeTabId) => {
    this.setState({ activeTabId });
  }

  activeTabContent() {
    const activeTabId = this.state.activeTabId;
    const activeTab = this.children.find(tab => tab.id === activeTabId);
    if (activeTab) {
      return activeTab.content;
    }
    return null;
  }

  render() {
    const activeTabId = this.state.activeTabId;
    const tabLinks = this.children.map(child => {
      const className = child.id === activeTabId ? 'active' : '';
      const onClick = () => { 
        this.activateTab(child.id) 
      }
      return <button key={'tab'+child.id} 
        className={className} onClick={onClick} > {child.title} </button>
    });
    return (
      <div className="tabs-container">
        <div className="tabs-links">{tabLinks}</div>
        {this.activeTabContent()}
      </div>
    );
  }

}

export function Tab(props) {
  return <div className="tab-content">{props.children}</div>
}